export default function getPositionClass(position: string): string {
  let positionClass: string;
  switch (position) {
    case "center":
      positionClass = "items-center";
      break;
    case "top":
      positionClass = "items-start";
      break;
    case "bottom":
      positionClass = "items-end";
      break;
    default:
      positionClass = "items-center";
  }
  return positionClass;
}
